import { PerspectiveCamera } from "three";
import { cameraZ, getContainerSize } from "../systems/config";

function createCamera(container) {
  const fov = 50;
  const near = 180;
  const far = 1800;
  const { aspect } = getContainerSize(container);

  const camera = new PerspectiveCamera(fov, aspect, near, far);
  camera.position.set(0, 0, cameraZ);

  return camera;
}

export { createCamera };
